import type { USAStateAcronym } from '@hc-frontend/core-types';

import { StrictConsentState } from './types';

/**
 * Check if a given state requires strict consent management
 */
export function isInStrictConsentState(params: {
  stateAcronym: USAStateAcronym;
}): boolean {
  const strictStates = Object.values(StrictConsentState) as string[];
  return strictStates.includes(params.stateAcronym);
}
